var _excluded = ["className", "date", "level", "onEditButtonClicked", "showEditButton", "showEmoji", "user"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Emoji } from './index';
import { dateUtils, userFullName } from '../utils';
var AssignmentCardHeader = function AssignmentCardHeader(_ref) {
  var className = _ref.className,
    date = _ref.date,
    level = _ref.level,
    onEditButtonClicked = _ref.onEditButtonClicked,
    showEditButton = _ref.showEditButton,
    showEmoji = _ref.showEmoji,
    user = _ref.user,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "d-flex justify-content-between mb-2 ".concat(className)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: "md",
    img: user === null || user === void 0 ? void 0 : user.avatar_url
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column px-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "section-header-title mb-1"
  }, userFullName(user)), " \xA0", showEmoji && /*#__PURE__*/React.createElement("small", {
    className: "fs-6"
  }, /*#__PURE__*/React.createElement(Emoji, {
    level: level
  }))), date && /*#__PURE__*/React.createElement("small", {
    className: "text-muted fw-light"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faClock
  }), "\xA0", dateUtils.fromNow(date)))), showEditButton && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    outline: true,
    onClick: onEditButtonClicked,
    size: "sm"
  }, "Edit Submission")));
};
AssignmentCardHeader.defaultProps = {
  className: undefined,
  onEditButtonClicked: undefined,
  showEditButton: false,
  showEmoji: false,
  level: 3
};
export default AssignmentCardHeader;